/**
 * CSS colors as PSD needs them. Effect colors carry no alpha (it's a separate opacity field), type
 * fill colors do, so parsing hands back both halves.
 */

import type { RGB, RGBA } from "ag-psd";
import { rgb } from "culori";

/** A function, not a constant: the color object is handed to ag-psd, which is free to mutate it. */
const opaqueBlack = () => ({ color: { r: 0, g: 0, b: 0 }, alpha: 1 });

export function parseCssColor(cssColor: string): {
  color: RGB;
  alpha: number;
} {
  const converted = rgb(cssColor.trim());
  if (!converted) return opaqueBlack();
  return {
    color: {
      r: channelTo255(converted.r),
      g: channelTo255(converted.g),
      b: channelTo255(converted.b),
    },
    alpha: clamp01(converted.alpha ?? 1),
  };
}

/** Alpha inside the descriptor, as ag-psd's four-component type `FillColor` wants it. */
export function parseCssColorAsRgba(cssColor: string): RGBA {
  const { color, alpha } = parseCssColor(cssColor);
  return { ...color, a: channelTo255(alpha) };
}

function channelTo255(value: number): number {
  return Math.round(clamp01(value) * 255);
}

function clamp01(value: number): number {
  return Math.min(1, Math.max(0, value));
}
